import i18n from 'i18next';

import enEditor from './entries/en';
import sharedEn from './entries/shared';

const DEFAULT_LOCALE_KEY = 'en';
const en = { ...enEditor, ...sharedEn };

i18n.init({
  // we init with resources
  resources: {
    en: {
      translations: en,
    },
  },
  fallbackLng: DEFAULT_LOCALE_KEY,
  debug: false,

  // have a common namespace used around the full app
  ns: ['translations'],
  defaultNS: 'translations',

  keySeparator: '',

  interpolation: {
    escapeValue: false, // not needed for react!!
    formatSeparator: ',',
  },

  react: {
    wait: true,
    defaultTransParent: 'div',
  },
});

export default i18n;
